import {
  BulkDeleteCallable,
  ConfirmTrashCallable,
  ContainerFileDropCallable,
  CreateWorkspaceCallable,
  CrossWorkspaceFileDropCallable,
  DeleteAutomationCallable,
  EditWorkspaceCallable,
  FileRecordVersionHistoryCallable,
  NewFolderCallable,
  PublishedFileDeleteCallable,
  PublishFileRecordCallable,
  RenameCanvasCallable,
  RenameChatCallable,
  RenameFileRecordCallable,
  ShareCanvasCallable,
  ShareFileRecordCallable,
  ShareWorkspaceCallable,
  WorkspaceAddModeCallable,
} from "@/action-dialog/callables";
import { FileConflictResolverProvider } from "@/components/FileConflictResolver";

/**
 * Mounts react-call roots for imperative action dialogs. Place inside
 * QueryClientProvider (and other app providers) so callables inherit context.
 *
 * Some dialogs need FileConflictResolverProvider; these roots sit at App
 * level (outside WorkspaceLayout), so we wrap them here rather than relying
 * on the layout-scoped provider.
 */
export function ActionDialogRoots() {
  return (
    <FileConflictResolverProvider>
      <ConfirmTrashCallable />
      <CreateWorkspaceCallable />
      <EditWorkspaceCallable />
      <ShareWorkspaceCallable />
      <NewFolderCallable />
      <ContainerFileDropCallable />
      <CrossWorkspaceFileDropCallable />
      <WorkspaceAddModeCallable />
      <DeleteAutomationCallable />
      <BulkDeleteCallable />
      <PublishedFileDeleteCallable />
      <RenameCanvasCallable />
      <RenameChatCallable />
      <RenameFileRecordCallable />
      <ShareCanvasCallable />
      <ShareFileRecordCallable />
      <PublishFileRecordCallable />
      <FileRecordVersionHistoryCallable />
    </FileConflictResolverProvider>
  );
}
